/**
 * TagsInput — lista de marcadores livres em chips (CRM-36).
 *
 * `Cliente.marcadores` aparecia no topo do Cliente 360 e nenhuma tela o
 * editava. O desenho é o das tags do cockpit do lead: chip com "x" para
 * remover e um campo "Enter adiciona".
 *
 * Props:
 *   - value: string[] (a lista atual).
 *   - onChange(listaNova): recebe a lista inteira.
 *   - idPrefix: prefixo único dos ids (o campo fica `${idPrefix}-novo`).
 *   - rotuloDoCampo: nome acessível do campo de digitação.
 *   - placeholder, maxLength, disabled.
 *
 * "VIP" e "vip" são o mesmo marcador: o repetido não entra.
 */
import React, { useState } from "react";
import { FiPlus, FiX } from "react-icons/fi";

import { LinhaDeEntrada, TagChip, TagsWrap } from "./styles";

export function adicionarMarcador(lista, texto) {
  const marcador = String(texto ?? "").trim();
  if (!marcador) return lista;
  const repetido = lista.some((m) => m.toLocaleLowerCase("pt-BR") === marcador.toLocaleLowerCase("pt-BR"));
  return repetido ? lista : [...lista, marcador];
}

function TagsInput({
  value = [],
  onChange,
  idPrefix,
  rotuloDoCampo = "Novo marcador",
  placeholder = "Novo marcador + Enter",
  maxLength = 40,
  disabled = false,
}) {
  const [texto, setTexto] = useState("");
  const lista = Array.isArray(value) ? value : [];

  const adicionar = () => {
    onChange(adicionarMarcador(lista, texto));
    setTexto("");
  };

  return (
    <div>
      {lista.length > 0 && (
        <TagsWrap role="list" aria-label="Marcadores">
          {lista.map((marcador) => (
            <TagChip key={marcador} role="listitem">
              {marcador}
              <button
                type="button"
                onClick={() => onChange(lista.filter((m) => m !== marcador))}
                aria-label={`Remover ${marcador}`}
                disabled={disabled}
              >
                <FiX size={11} aria-hidden="true" />
              </button>
            </TagChip>
          ))}
        </TagsWrap>
      )}
      <LinhaDeEntrada>
        <input
          id={`${idPrefix}-novo`}
          className="input"
          type="text"
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              // Enter dentro do form enviaria o cadastro inteiro.
              e.preventDefault();
              adicionar();
            }
          }}
          aria-label={rotuloDoCampo}
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
        />
        <button
          type="button"
          className="btn btn--secondary btn--sm"
          onClick={adicionar}
          aria-label={`Adicionar ${rotuloDoCampo.toLocaleLowerCase("pt-BR")}`}
          disabled={disabled}
        >
          <FiPlus size={13} aria-hidden="true" />
        </button>
      </LinhaDeEntrada>
    </div>
  );
}

export default TagsInput;
